import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SpecificSteelProfileForm} from '../specific-steel-profile-form';
import {SquaredProfile} from '../../steel-profile';
import {AbstractControl, FormBuilder, Validators} from '@angular/forms';
import {CintacValidators} from '../../../_shared/cintac-validators';

@Component({
    selector: 'app-squared-profile-form',
    templateUrl: './squared-profile-form.component.html',
    styleUrls: ['../../../project/project-form-components/project-form.css']
})
export class SquaredProfileFormComponent implements OnInit, SpecificSteelProfileForm {
    @Input() profile: SquaredProfile;
    @Output() specificIsValid = new EventEmitter<boolean>();
    profileData: AbstractControl;

    formErrors = {
        'A': '',
        'B': '',
        'e': '',
        'l': ''
    };

    validationMessages = {
        'A': {
            'required': 'Ingresar valor de B.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'B': {
            'required': 'Ingresar valor de H.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'e': {
            'required': 'Ingresar valor de eo.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'l': {
            'required': 'Ingresar valor de es.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
    };

    constructor(private fb: FormBuilder) {
        this.profileData = this.fb.group({
            A: [null, [Validators.required, CintacValidators.positiveFloatValidator()]],
            B: [null, [Validators.required, CintacValidators.positiveFloatValidator()]],
            e: [null, [Validators.required, CintacValidators.positiveFloatValidator()]],
            l: [null, [Validators.required, CintacValidators.positiveFloatValidator()]]
        });
    }

    ngOnInit() {
        this.profileData.reset({
            A: this.profile.A,
            B: this.profile.B,
            e: this.profile.e,
            l: this.profile.l
        });
        this.profileData.valueChanges.subscribe(values => this.onValueChanged());
    }

    private onValueChanged() {
        const form = this.profileData;
        this.updateProfile();
        Object.keys(this.formErrors).forEach(field => {
            this.formErrors[field] = '';
            const control = form.get(field);
            if (control.dirty && !control.valid) {
                const messages = this.validationMessages[field];
                for (const key in control.errors) {
                    if (control.errors.hasOwnProperty(key)) {
                        this.formErrors[field] += messages[key] + ' ';
                    }
                }
            }
        });
        this.specificIsValid.emit(this.profileData.valid);
    }

    updateProfile() {
        this.profile.A = this.profileData.value.A;
        this.profile.B = this.profileData.value.B;
        this.profile.e = this.profileData.value.e;
        this.profile.l = this.profileData.value.l;
    }

}



// WEBPACK FOOTER //
// ./src/app/steel-profile/steel-profile-forms/squared-profile-form/squared-profile-form.component.ts